import React from 'react';
import CollapsibleCardWithStatusChartCareTask from '../../component/ReportData/CollapsibleCardWithStatusChartCareTask';
import { withStyles } from '@material-ui/styles';
import { withNamespaces } from 'react-i18next';
import * as _ from 'lodash';
import ReportPage from 'appModule/reporting/component/ReportPDF/ReportPage';
import ReportDataViewTable from 'appModule/reporting/component/ReportPDF/ReportDataView/ReportDataViewTable';
import ReportDataViewTableHeader from 'appModule/reporting/component/ReportPDF/ReportDataView/ReportDataViewTableHeader';
import ReportDataViewTableCell from 'appModule/reporting/component/ReportPDF/ReportDataView/ReportDataViewTableCell';

const styles = {
  collapsibleCardGrid: {
    backgroundColor: '#212121',
    fontSize: '24px',
  },
  description: {
    marginTop: '5px',
    fontSize: '12px',
    letterSpacing: '0.08px',
    marginBottom: '5px',
    color: '#212121',
  },
  paper: {
    borderRadius: '5px',
    width: '820px',
  },
  patientProgramLabel: {
    fontSize: '12px',
    color: '#9E9E9E',
  },
  patientProgramGrid: {
    cursor: 'pointer',
    width: '9px',
    height: '15px',
    float: 'right',
    borderRadius: '14px',
    opacity: 1,
    marginRight: '3px',
  },
  patientProgramGrid2: {
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  patientProgramGridContent: {
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  patientProgramDetails: {
    fontSize: '14px',
  },
  reportInformationTitle1: {
    textAlign: 'right',
    fontSize: '12px',
    color: '#f44336',
  },
  reportInformationTitle2: {
    textAlign: 'right',
    fontSize: '12px',
    color: '#9e9e9e',
    float: 'right',
  },
  reportInformationPickerGrid: {
    justifyContent: 'center',
    alignContent: 'center',
    width: '100%',
  },
  advancePropsTypograph: {
    height: '100px',
    alignItems: 'center',
    display: 'flex',
  },
  cardLabel: {
    fontFamily: 'Roboto',
    fontWeight: 'medium',
    fontSize: '12px',
    color: '#FFFFFF',
    paddingTop: 16,
  },
  cardDetail: {
    fontFamily: 'Roboto',
    fontSize: '21px',
    color: '#FFFFFF',
  },
  vitalDiv: {
    borderLeft: '1px solid',
    height: '100px',
    marginTop: 3,
  },
  careTaskLegend: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '12px',
  },
  careTaskLegendCategoryDiv: {
    display: 'flex',
    alignItems: 'center',
  },
  careTaskLegendCategoryLabel: {
    color: '#212121',
    fontWeight: '400',
    fontSize: '14px',
    marginLeft: '6px',
  },
  careTaskSummaryCardPaper: {
    display: 'flex',
    borderRadius: 3,
    marginLeft: 16,
    marginRight: 16,
    marginBottom: 20,
    boxShadow: 'none',
  },
  careTaskInfoTyphograph: {
    fontSize: '12px',
  },
  careTaskInfoGrid: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '10px',
  },
  careTaskInfoGrid2: {
    justifyContent: 'space-between',
  },
  careTaskToolTipCard: {
    height: 'auto',
    width: '275px',
    marginBottom: '10px',
    marginRight: '10px',
    padding: '12px',
    borderRadius: '8px',
  },
  selectionGridThreshold: {
    cursor: 'pointer',
    width: '9px',
    height: '15px',
    float: 'right',
    borderRadius: '14px',
    opacity: 1,
    marginRight: '3px',
  },
  refreshData: {
    fontSize: '12px',
    color: '#FFFFFF',
  },
  fabBtn: {
    height: '10px',
    width: '38px',
    float: 'right',
    backgroundColor: 'white',
    boxShadow: 'none',
  },
  iconClose: {
    color: '#4c4b4b',
    fontSize: '20px',
  },
  menuItemTypograph: {
    paddingLeft: '10px',
    textAlign: 'left',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: '0px',
    color: '#474747',
    opacity: 1,
  },
  menuItemTypographData: {
    paddingLeft: '10px',
    textAlign: 'left',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '500',
    letterSpacing: '0px',
    color: '#474747',
    opacity: 1,
  },
  dataViewSelect: {
    paddingLeft: '16px',
    paddingTop: '16px',
    paddingBottom: '16px',
  },
  paperBoxShadow: {
    boxShadow: '0px 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 1px 1px rgb(0 0 0 / 0%), 0px 0px 0px 0px rgb(0 0 0 / 0%)',
  },
  statusInfoBoxShadow: {
    boxShadow: '0px 2px 11px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  avatarTitle: {
    fontSize: '24px',
  },
  dialogAction: {
    justifyContent: 'space-between',
    paddingLeft: '25px',
    paddingRight: '25px',
    paddingBottom: '25px',
  },
  vitalCardTooltip: {
    height: 'auto',
    width: '275px',
    marginBottom: '10px',
    marginRight: '10px',
    padding: '12px',
    borderRadius: '8px',
  },
  container: {
    backgroundColor: 'white',
    width: '21cm',
    height: '29.7cm',
    overflow: 'hidden',
  },
  metadataTitle: {
    width: '40%',
    fontSize: 14,
  },
  metadataValue: {
    width: '60%',
    fontSize: 14,
  },
  tdHeader: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    textAlign: 'left',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 8,
  },
  td: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    textAlign: 'left',
    fontSize: 12,
    padding: 8,
  },
  tdTotal: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    fontSize: 12,
    padding: 8,
  },
  metadataSpace: {
    height: 10,
  },
  dataViewTitle: {
    padding: '15px',
    backgroundColor: 'black',
    color: 'white',
    fontSize: '18px',
  },
};
@withNamespaces('reports', { wait: true })
@withStyles(styles, { index: 1 })
class ReportingPDF extends React.Component {
  state = {
    reportData: null,
    careTaskData: {
      summaryData: {
        totalTasks: 0,
        completedScheduledTasks: 0,
        completedOneTimeTasks: 0,
        missedScheduledTasks: 0,
        missedOneTimeTasks: 0,
        overallAdherenceRate: 0,
        type: 'OVERALL',
        status: true,
      },
      enrolledProgramData: [],
      chartData: [],
      loading: false,
      selectedView: null,
      selectedData: null,
      dataView: [],
      selectedEnrolledProgramme: [],
    },
  };

  constructor(props) {
    super(props)

    if (this.props.location.query['session-language']) {
      this.props.i18n.changeLanguage(this.props.location.query['session-language']);
    }
  }

  async componentDidMount() {
    await this.getReportData();
  }

  getReportData() {
    const { API_URL } = window.MILO_CONFIG;
    const { reportId, 'session-token': sessionToken } = this.props.location.query;
    fetch(`${API_URL}/reports/${reportId}?session-token=${sessionToken}`)
      .then((res) => res.json())
      .then((json) => json.value)
      .then((response) => {
        const { report } = response;
        const module = _.find(report.modules, { key: 'care_task' });
        const component = _.find(module.components, { key: 'monthly_adherence' });
        const careTaskTypes = _.find(module.filters, { key: 'type_of_care_task' });
        const vitalTypes = _.find(module.filters, { key: 'vital_type' });
        const timeTaken = _.find(module.filters, { key: 'time_taken' });

        this.setState(
          {
            reportData: response.report,
            module,
            component,
            careTaskTypes,
            vitalTypes,
            timeTaken,
            careTaskData: {
              ...this.state.careTaskData,
              selectedView: component.chartType,
            },
          },
          async () => await this.getSummary(),
        );
      });
  }

  getSummary = async () => {
    const { 'session-token': sessionToken } = this.props.location.query;
    const { reportData, careTaskTypes, vitalTypes, timeTaken } = this.state;
    const { API_URL } = window.MILO_CONFIG;

    fetch(`${API_URL}/reports/provider/patient/overall/careTask/adherence/summary`, {
      method: 'POST',
      headers: {
        'session-token': sessionToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        dateStart: reportData.dateStart,
        dateEnd: reportData.dateEnd,
        epIds: reportData.enrolledPrograms,
        patientIds: reportData.patient.ids,
        careTaskTypes: careTaskTypes.selected,
        vitalTypes: vitalTypes.selected,
        timeTaken: timeTaken.selected,
      }),
    })
      .then((res) => res.json())
      .then((json) => json.value)
      .then((summaryData) => {
        this.setState(
          {
            careTaskData: {
              ...this.state.careTaskData,
              summaryData,
            },
          },
          async () => await this.getChartData(),
        );
      });
  };

  getChartData = async () => {
    const { 'session-token': sessionToken } = this.props.location.query;
    const {
      reportData,
      careTaskTypes,
      vitalTypes,
      timeTaken,
      careTaskData: { selectedView },
    } = this.state;
    const { API_URL } = window.MILO_CONFIG;

    fetch(`${API_URL}/reports/provider/patient/overall/careTask/adherence/chart`, {
      method: 'POST',
      headers: {
        'session-token': sessionToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        dateStart: reportData.dateStart,
        dateEnd: reportData.dateEnd,
        epIds: reportData.enrolledPrograms,
        patientIds: reportData.patient.ids,
        careTaskTypes: careTaskTypes.selected,
        vitalTypes: vitalTypes.selected,
        timeTaken: timeTaken.selected,
        chartType: selectedView,
      }),
    })
      .then((res) => res.json())
      .then((json) => json.value)
      .then((chartData) => {
        this.setState({
          careTaskData: {
            ...this.state.careTaskData,
            chartData: chartData.lineChartData || chartData.dataView,
          },
        });
      });
  };

  renderLineChart = () => {
    const { classes, isEmbedded, t } = this.props;
    const { page = 1, totalPages = 10 } = this.props.location.query;

    return (
      <ReportPage isEmbedded={isEmbedded} page={page} totalPages={totalPages}>
        <CollapsibleCardWithStatusChartCareTask
          isEmbedded={isEmbedded}
          mode={'view'}
          pdf={true}
          status={'pristine'}
          title="Care Tasks"
          step={4}
          classes={classes}
          data={this.state.careTaskData}
          refresh={null}
          changeType={null}
        />
      </ReportPage>
    );
  };

  renderDataView = () => {
    const { isEmbedded } = this.props;
    const { page = 1, totalPages = 10 } = this.props.location.query;
    const titles = ['Month', 'Adherence'];
    const tableData = this.state.careTaskData.chartData.map((data) => {
      return [data.reportDate.display, data.adherence && `${data.adherence}%`];
    });
    return (
      <ReportPage isEmbedded={isEmbedded} page={page} totalPages={totalPages}>
        <ReportDataViewTable dataViewTitle={'Monthly Adherence'}>
          <ReportDataViewTableHeader titles={titles} />
          <ReportDataViewTableCell tableData={tableData} />
        </ReportDataViewTable>
      </ReportPage>
    );
  };

  render = () => {
    const {
      careTaskData: { selectedView = 'LINE_CHART' },
    } = this.state;
    if (!selectedView) return null;
    if (selectedView === 'LINE_CHART') {
      return this.renderLineChart();
    }

    if (selectedView == 'DATA_VIEW') {
      return this.renderDataView();
    }

    return null;
  };
}

export default ReportingPDF;
